import { BlockModel } from '../utils/Models';
import { DataGrid, GridColumns, GridSortItem } from "@mui/x-data-grid";
import { Box, IconButton } from '@mui/material';
import { DateTime } from 'luxon';
import { AddCircle, RemoveCircle } from '@mui/icons-material';
import { Fragment } from 'react';
import { Colors } from '../../config/Constants';

// Booking grid component
export function BlocksTable(props: {
  blocksList: BlockModel[],
  setParentState: any,
  updateBlockQuanity: (blockId: number, newQuantity: number) => void,
  containerClass: any
}) {
  const dgProps = {
    disableColumnMenu: true,
    disableColumnFilter: true,
    className: 'gbk-dg',
    rowHeight: 50,
    pageSize: 10,
    sortModel: [{ field: 'id', sort: 'desc' }] as GridSortItem[],
    columns: [{
      field: 'brand',
      headerName: 'Brand',
      width: 100,
      align: 'center',
      renderCell: o => o.row.bike.brand,
      sortable: false
    }, {
      field: 'name',
      headerName: 'Vehicle Name',
      width: 200,
      align: 'center',
      renderCell: o => (<span><div className='gbk-dg-image-text'>{o.row.bike.name}</div>&nbsp;&nbsp;<img className='gbk-dg-image' alt='bike' src={o.row.bike.image} /></span>),
      sortable: false
    }, {
      field: 'blockStart',
      headerName: 'Start Date',
      width: 200,
      align: 'center',
      valueFormatter: o => DateTime.fromMillis(Number(o.value)).toLocaleString(DateTime.DATETIME_MED),
      sortable: false
    }, {
      field: 'blockEnd',
      headerName: 'End Date',
      width: 200,
      align: 'center',
      valueFormatter: o => DateTime.fromMillis(Number(o.value)).toLocaleString(DateTime.DATETIME_MED),
      sortable: false
    }, {
      field: 'quantity',
      headerName: 'Quantity',
      width: 300,
      renderCell: o => (
        <Fragment>
          <IconButton color='primary' onClick={() => props.updateBlockQuanity(o.row.id, o.row.quantity - 1)}><RemoveCircle /></IconButton>
          {o.row.quantity}
          <IconButton color='primary' onClick={() => props.updateBlockQuanity(o.row.id, o.row.quantity + 1)}><AddCircle /></IconButton>
          &nbsp;&nbsp;
          <p className='grey-text-medium'>(Available Quantity: {o.row.availableQuantity})</p>
        </Fragment>
      ),
      align: 'center',
      sortable: false
    }] as GridColumns
  };

  return <div className={props.containerClass}>
    {/* PC Grid */}
    <DataGrid
      sx={{ display: { xs: 'none', md: 'flex' } }}
      disableColumnMenu={dgProps.disableColumnMenu}
      disableColumnFilter={dgProps.disableColumnFilter}
      className={dgProps.className}
      rowHeight={dgProps.rowHeight}
      rows={props.blocksList || []}
      columns={dgProps.columns}
      pageSize={dgProps.pageSize}
      rowsPerPageOptions={[dgProps.pageSize]}
      sortModel={dgProps.sortModel}
      disableSelectionOnClick
    />
    {/* Phone Grid */}
    <DataGrid
      sx={{ display: { xs: 'flex', md: 'none' } }}
      disableColumnMenu={dgProps.disableColumnMenu}
      disableColumnFilter={dgProps.disableColumnFilter}
      className={`${dgProps.className} phone`}
      rowHeight={163}
      rows={props.blocksList || []}
      columns={dgProps.columns}
      pageSize={dgProps.pageSize}
      rowsPerPageOptions={[dgProps.pageSize]}
      disableSelectionOnClick
      headerHeight={0}
      sortModel={dgProps.sortModel}
      components={{
        Row: (data: { row: BlockModel }) => (
          <Box className='gbk-dg-row-phone'>
            <Box className='gbk-dg-row-phone-header' key={1} >
              Block ID #{data.row.id}
            </Box>
            <Box
              className='gbk-dg-row-phone-body'
              key={2}
            >
              <div style={{ display: 'inline-block', verticalAlign: 'top', paddingBottom: '8px' }}>
                <b style={{ color: Colors.primary, paddingTop: '4px', paddingBottom: '8px', display: 'inline-block' }}>{data.row.bike?.brand} {data.row.bike?.name}</b> <br />
                Start: <b style={{ fontSize: '14px' }}>{DateTime.fromMillis(Number(data.row.blockStart)).toLocaleString(DateTime.DATETIME_MED)}</b> <br />
                End: <b style={{ fontSize: '14px' }}>{DateTime.fromMillis(Number(data.row.blockEnd)).toLocaleString(DateTime.DATETIME_MED)}</b> <br />
                {data.row.updatedAt ? (
                  <Fragment>
                    Created at: <b style={{ fontSize: '14px' }}>{DateTime.fromMillis(new Date(data.row.updatedAt).getTime()).toLocaleString(DateTime.DATETIME_MED)}</b> <br />
                  </Fragment>
                ) : ''}

              </div>

              <div style={{ float: 'right', position: 'absolute', right: 0, top: '20px' }}>
                <IconButton color='primary' onClick={() => props.updateBlockQuanity(data.row.id as number, data.row.quantity - 1)}><RemoveCircle /></IconButton>
                {data.row.quantity}
                <IconButton color='primary' onClick={() => props.updateBlockQuanity(data.row.id as number, data.row.quantity + 1)}><AddCircle /></IconButton>
                &nbsp;&nbsp;
                <p className='no-margin grey-text-medium'>(Available: {data.row.availableQuantity})</p>
              </div>
            </Box>
          </Box>
        )
      }}
    />
  </div >
}